// import { Content, Footer, Header, Sidebar } from 'components/Layout';
import React, { useEffect, Fragment } from 'react';
import Sidebar from './sidebar';
import Footer from './footer';

const MainLayout = (props) => {

    const { children } = props;

    return (
        <Fragment>
            <Sidebar />
            {children}
            <Footer />
        </Fragment>
    )
}

export default MainLayout;
